module.exports = __webpack_public_path__ + "media/images/icon_job_category2-4c31abc07ca7040484f9278ecaae59d3.png";